// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.qq
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import axios from 'axios'
import qs from 'qs'
// import Swiper from 'swiper';
import Swiper from 'swiper'; // 注意引入的是Swiper
import 'swiper/css/swiper.min.css' // 注意这里的引入

// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/swiper.min.css'
// import 'swiper/swiper-bundle.css'
// import 'swiper/dist/css/swiper.css';
// Vue.use(VueAwesomeSwiper)


// @import url("../../node_modules/swiper/css/swiper.css");

import port from '@/js/port.js'
import ajax from '@/js/axios.js'
// import './css/custom.css'
import 'font-awesome/scss/font-awesome.scss'
import './css/pubStyle.css'

// import 'babel-polyfill'


// import Share from 'vue-social-share'wq
// Vue.use(Share)
import 'vue-social-share/dist/client.css';
// import '@/common/font/font.css';
import '@/common/font/font.css'

//Vue.use(require('vue-wechat-title'));

//import vshare from 'vshare'
//Vue.use(vshare)
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});
//import './css/custom.css'
//import './css/home.css'
//import './css/optimized.css'
//import './css/styles-l.css'
// import './css/styles-m.css'
//import './css/type17.css'
import util from '@/js/util.js'
Vue.prototype.$qs=qs;
Vue.prototype.$port = port;
Vue.prototype.$axios=axios;
Vue.prototype.$ajax=ajax.post;
Vue.prototype.$Islogin=util.ISlogin;
//Vue.prototype.$post=ajax.postO;
Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
//保留两位小数点过滤
Vue.filter('toFixedFilter', function(value) {
	if(value == "" || typeof value == "undefined"||value==0) {
		return 0.00;
	} else {
		return Number(value).toFixed(2);
	}
})
//时间过滤器(年/月/日)
Vue.filter('dateFormatFilter', function(value) {
	if(value == "" || typeof value == "undefined") {
		return "";
	} else {
		 return value.toString().split('T')[0];
	}
})


// WEBPACK FOOTER //
// ./src/main.js